import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Tab from "./Tab"
import IdGenerator from "../../../../IdGenerator"

const useStyles = makeStyles(() => ({
  unselectedTab: {
    opacity: 0.5
  },
  selectedTab: {
    opacity: 1
  }
}))

const TabPanelLayout = (props) => {
  const classes = useStyles()
  // Sonar lists 'Component' as unused. This is a false positive and is fixed in Sonar 8.5.
  const {
    data,
    Component,
    TabPanelLayoutProps,
    TabsContainerProps,
    TabProps,
    ...rest
  } = props
  const [selectedTab, setSelectedTab] = useState(0)
  const generator = new IdGenerator()

  const changeTab = (newTab) => {
    if (selectedTab !== newTab) {
      setSelectedTab(newTab)
    }
  }

  return (
    <div
      name="Layout"
      className="dashboard-widget-layout"
      {...TabPanelLayoutProps}
    >
      <Box
        name="TabRow"
        className="dashboard-widget-layout-tabrow"
        style={{ display: "flex" }}
        {...TabsContainerProps}
      >
        {data.items.map((tabData, id) => (
          <Tab
            className={
              id === selectedTab ? classes.selectedTab : classes.unselectedTab
            }
            data={tabData}
            key={generator.getId(tabData)}
            id={id}
            onClick={changeTab}
            selected={id === selectedTab}
            {...TabProps}
          />
        ))}
      </Box>
      {data.items.map((tabData, id) => (
        <div
          key={generator.getId(tabData)}
          name="TabPanelContent"
          style={{
            display: id === selectedTab ? "block" : "none"
          }}
          className="dashboard-widget-layout-tabpanel-content"
        >
          <Component
            {...rest}
            data={tabData}
            title={rest.title || data.title || tabData.title}
          />
        </div>
      ))}
    </div>
  )
}

TabPanelLayout.propTypes = {
  data: PropTypes.object.isRequired,
  // Required to avoid cyclic dependency with DashboardElement
  Component: PropTypes.func.isRequired,
  TabPanelLayoutProps: PropTypes.object,
  TabsContainerProps: PropTypes.object,
  TabProps: PropTypes.object
}

TabPanelLayout.defaultProps = {
  TabPanelLayoutProps: {},
  TabsContainerProps: {},
  TabProps: {}
}

export default TabPanelLayout
